import { Branding, DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import BaseToggleView from "components/shared/views/BaseToggleView";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React, { useState } from "react";

import UIAmountInput from "components/ui/UIAmountInput";
import "./styles.css";
/**
 * @function SpendControlsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SpendControlsPage
 */

export default function SpendControlsPage(props) {
  const transactionAmount = props.transactionAmount ?? "100.00";
  const monthlyAmount = props.monthlyAmount ?? "1,500.00";
  const currentSpend = props.currentSpend ?? "0.00";

  const navigate = useRoute();
  const cancel = evt => navigate(-1);

  return (
    <MainContentContainer className="spend-controls-page" header={
      <MainContentHeader text="Spend Controls" 
      dataPoint="Spend_Controls"/>
    }>
      <FormContainer>
        <FormRow className="spend-limits-row bottom-border">
          <div className="main-text"><span>Spend Limits</span></div>
          <div className="sub-text"><span>Deny a purchase if the amount exceeds the limits below.</span></div>
        </FormRow>

        <SpendControlsLimit
          mainText="Per Transaction"
          subText="Deny transactions exceeding the transaction spend limit."
          value={ transactionAmount } 
          dataPoint="Spend_Controls_Transaction"
          checked={true}/>

        <Branding id="monthly_spendlimit_chw23" value="true">
          <SpendControlsLimit 
            mainText="Per Month"
            subText={
              <>
                <p className="sub-text">Deny transactions exceeding the monthly spend limit.</p>
                <p className="sub-text">Current Spend: ${currentSpend}</p>
                <p className="sub-text">(Excludes recurring transactions)</p>
              </>
            }
            value={ monthlyAmount } 
            dataPoint="Spend_Controls_Monthly"
            checked={true} />
        </Branding>

        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Apply" dataPoint="Spend_Controls_Apply"/>
          </DisabledPrompt>
          <UICancelButton text="Cancel" onClick={ cancel } dataPoint="Spend_Controls_Cancel"/>
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}

function SpendControlsLimit(props) {
  const mainText = props.mainText ?? "";
  const subText = props.subText ?? "";
  const [value,setValue] = useState(props.value ?? "1,500.00");

  const setLimit=(val)=>{

    setValue(val)
  }
  return (
    <>
      <FormRow>
        <BaseToggleView mainText={ mainText }
         subText={ subText }
        checked={true} className="hide-chevron-icon"
        dataPoint={props.dataPoint ? props.dataPoint+"_Amount":""}
        toggleBlock= {    
          <FormRow>
            <UIAmountInput onChange={setLimit} value={ value } dataPoint={props.dataPoint ? props.dataPoint+"_Amount":""}/>
          </FormRow>
        }
        />
      </FormRow>

     
    </>
  );
}